// function to create delay
export const addDelay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms))
